import {get} from './fetch';
import {CacheStorage} from './cache-storage';

let fetched = [];
const cacheName = 'prefetch';

export const htmlPrefetcher = {
  storage: new CacheStorage(window.localStorage, cacheName),

  /**
   * @param {String[]} urls
   * @returns {Promise}
   */
  request(urls = []) {
    // Reset fetched until localcache is in use
    fetched = [];
    return Promise.all(
      urls.map(url =>
        get(url).then(response => {
          fetched = [].concat(fetched, url);
          return response.text();
        }),
      ),
    );
  },

  /**
   * @param {String[]} locations
   * @returns {Boolean[]}
   */
  checkAll(locations) {
    return locations.map(url => this.check(url));
  },

  /**
   * Check if a url has already been fetched
   * @param {String} location
   * @returns {Boolean}
   */
  check(location) {
    return fetched.includes(location);
  },

  /**
   * @param {String[]} keys
   */
  invalidate(keys = []) {
    keys.forEach(key => this.storage.remove(key));
  },
};
